import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
} from "@mui/material";

function SplitPaymentModal({ open, invoice, onClose, onSubmit, onUpload }) {
  const [paymentDate, setPaymentDate] = useState(new Date().toISOString().slice(0, 10));
  const [amountRon, setAmountRon] = useState("");
  const [amountValuta, setAmountValuta] = useState("");
  const [valuta, setValuta] = useState(invoice?.valuta || "RON");
  const [paymentMethod, setPaymentMethod] = useState("OP");
  const [opNumber, setOpNumber] = useState("");
  const [note, setNote] = useState("");
  const [file, setFile] = useState(null);

  const reset = () => {
    setPaymentDate(new Date().toISOString().slice(0, 10));
    setAmountRon("");
    setAmountValuta("");
    setValuta(invoice?.valuta || "RON");
    setPaymentMethod("OP");
    setOpNumber("");
    setNote("");
    setFile(null);
    onClose();
  };

  const save = async () => {
    let docUrl = null;
    if (file) {
      const uploaded = await onUpload(file);
      docUrl = uploaded.url;
    }

    await onSubmit({
      payment_date: paymentDate,
      amount_ron: Number(amountRon || 0),
      amount_valuta: Number(amountValuta || 0),
      valuta,
      payment_method: paymentMethod,
      op_number: opNumber || null,
      note,
      doc_plata_url: docUrl,
    });

    reset();
  };

  return (
    <Dialog open={open} onClose={reset} fullWidth maxWidth="sm">
      <DialogTitle>Split bill: {invoice?.denumire}</DialogTitle>
      <DialogContent>
        <Box className="sf-modal-grid">
          <TextField
            type="date"
            label="Data platii"
            InputLabelProps={{ shrink: true }}
            value={paymentDate}
            onChange={(e) => setPaymentDate(e.target.value)}
          />
          <TextField
            select
            label="Valuta plata"
            value={valuta}
            onChange={(e) => setValuta(e.target.value)}
          >
            <MenuItem value="RON">RON</MenuItem>
            <MenuItem value="EUR">EUR</MenuItem>
            <MenuItem value="USD">USD</MenuItem>
          </TextField>
          <TextField
            type="number"
            label="Suma RON"
            value={amountRon}
            onChange={(e) => setAmountRon(e.target.value)}
          />
          <TextField
            type="number"
            label="Suma valuta"
            value={amountValuta}
            onChange={(e) => setAmountValuta(e.target.value)}
          />
          <TextField
            select
            label="Mod de plata"
            value={paymentMethod}
            onChange={(e) => setPaymentMethod(e.target.value)}
          >
            <MenuItem value="OP">OP</MenuItem>
            <MenuItem value="CARD">Card</MenuItem>
            <MenuItem value="RAMBURS">Ramburs</MenuItem>
          </TextField>
          <TextField
            label="Evidenta plata"
            value={opNumber}
            onChange={(e) => setOpNumber(e.target.value)}
          />
          <TextField
            multiline
            minRows={2}
            label="Note"
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
          <Button component="label" variant="outlined">
            Upload doc plata
            <input hidden type="file" onChange={(e) => setFile(e.target.files?.[0] || null)} />
          </Button>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={reset}>Cancel</Button>
        <Button variant="contained" onClick={save}>
          Inregistreaza plata
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SplitPaymentModal;
